import { render, staticRenderFns } from "./BuyerAdsFilter.vue?vue&type=template&id=428fb047&"
import script from "./BuyerAdsFilter.vue?vue&type=script&lang=js&"
export * from "./BuyerAdsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports